import React, { useEffect, useState, createContext, useContext } from 'react';
interface ThemeContextType {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
}
const ThemeContext = createContext<ThemeContextType>({
  isDarkMode: false,
  toggleDarkMode: () => {}
});
export const useTheme = () => useContext(ThemeContext);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    // Check system preference on mount
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    setIsDarkMode(prefersDark);
  }, []);
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);
  return <ThemeContext.Provider value={{
    isDarkMode,
    toggleDarkMode
  }} data-id="element-1106">
      {children}
    </ThemeContext.Provider>;
}